import { TEMPLATES, InvitationColorTheme } from "./store/services/invitations/dto/invitations.dto";

export interface TemplateColorObject {
	id: number;
	main: string;
	background?: string;
	secondaryBackground?: string;
	overlay: string;
	font: {
		primary: string;
		secondary: string;
		tertiary: string;
	};
	button: {
		background: string;
		text: string;
	};
	addTemplateButton: {
		background: string;
		text: string;
	};
	entrance: {
		background: string;
		lid: string;
		envelope_background: string;
		envelope: string;
		view_invitation_btn?: string;
	};
	footer: string;
	fader?: string;
}

export const InvitationColorMatrix: Record<number, Record<number, TemplateColorObject>> = {
	[TEMPLATES.TEMPLATES01]: {
		[InvitationColorTheme.COLOR01]: {
			id: InvitationColorTheme.COLOR01,
			main: "#ecae74",
			overlay: "linear-gradient(180deg, rgba(203, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 100%)",
			font: {
				primary: "#4b4b4b",
				secondary: "#212121",
				tertiary: "#9f3d0c"
			},
			button: {
				background: "linear-gradient(180deg, rgb(242 179 115) 0%, rgb(164 121 80) 100%);",
				text: "#fff"
			},
			addTemplateButton: {
				background: "#e37610",
				text: "#fff"
			},
			entrance: {
				background: "linear-gradient(45deg, #ffe0be, #ffffff)",
				lid: "100px solid #eca250",
				envelope_background: "#eca250",
				envelope: `
				border-right: 130px solid #f2b776;
				border-bottom: 100px solid #f2b776;
				border-left: 150px solid #f4cea4;`,
				view_invitation_btn: "#000"
			},
			footer: "#ecae74"
		},
		[InvitationColorTheme.COLOR02]: {
			id: InvitationColorTheme.COLOR02,
			main: "#f08c8b",
			overlay: "linear-gradient(180deg, rgb(254 254 254) 0%, rgba(255, 255, 255, 1) 100%);",
			font: {
				primary: "#4b4b4b",
				secondary: "#474747",
				tertiary: "#f08c8b"
			},
			button: {
				background: "linear-gradient(180deg, rgb(253 132 129) 0%, rgb(174 90 88) 100%)",
				text: "#fff"
			},
			addTemplateButton: {
				background: "#d4433f",
				text: "#fff"
			},
			entrance: {
				background: "linear-gradient(45deg, #ffc7c6, #ffffff)",
				lid: "100px solid #fe8482",
				envelope_background: "#fe8482",
				envelope: `
				border-right: 130px solid #fa625e;
				border-bottom: 100px solid #fa625e;
				border-left: 150px solid #fba8a6;`,
				view_invitation_btn: "#000"
			},
			footer: "#f08c8b"
		},
		[InvitationColorTheme.COLOR03]: {
			id: InvitationColorTheme.COLOR03,
			main: "#9d302e",
			overlay: "linear-gradient(180deg, rgb(255 226 225) 0%, rgb(232 228 225) 100%);",
			font: {
				primary: "#4b4b4b",
				secondary: "#474747",
				tertiary: "#9d302e"
			},
			button: {
				background: "linear-gradient(180deg, rgb(200 96 94) 0%, rgb(157 48 46) 100%);",
				text: "#fff"
			},
			addTemplateButton: {
				background: "#9d302e",
				text: "#fff"
			},
			entrance: {
				background: "linear-gradient(45deg, #ffc2c1, #ffffff)",
				lid: "100px solid #c3504e",
				envelope_background: "#c3504e",
				envelope: `
				border-right: 130px solid #893331;
				border-bottom: 100px solid #893331;
				border-left: 150px solid #d05b58;`,
				view_invitation_btn: "#000"
			},
			footer: "#9d302e"
		},
		[InvitationColorTheme.COLOR04]: {
			id: InvitationColorTheme.COLOR04,
			main: "#d9d2e9",
			overlay: "linear-gradient(180deg, rgb(227 216 255) 0%, rgb(232 228 225) 100%);",
			font: {
				primary: "#4b4b4b",
				secondary: "#474747",
				tertiary: "#3500c4"
			},
			button: {
				background: "linear-gradient(180deg, rgb(106 95 133) 0%, rgb(147 109 235) 100%)",
				text: "#fff"
			},
			addTemplateButton: {
				background: "#8170a6",
				text: "#fff"
			},
			entrance: {
				background: "linear-gradient(45deg, #d5c3fe, #ffffff)",
				lid: "100px solid #e1d4ff",
				envelope_background: "#e1d4ff",
				envelope: `
				border-right: 130px solid #d5c3fe;
				border-bottom: 100px solid #d5c3fe;
				border-left: 150px solid #eae1fe;`,
				view_invitation_btn: "#000"
			},
			footer: "#d9d2e9"
		}
	},
	[TEMPLATES.TEMPLATES02]: {
		[InvitationColorTheme.COLOR01]: {
			id: InvitationColorTheme.COLOR01,
			main: "#c44d8f",
			overlay: "linear-gradient(180deg, rgba(243, 194, 215, 1) 0%, rgba(255, 255, 255, 1) 100%)",
			fader: "linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgb(244 196 216) 80%)",
			font: {
				primary: "#4b4b4b",
				secondary: "#000",
				tertiary: "#fff"
			},
			button: {
				background: "linear-gradient(180deg, rgb(127 48 93) 0%, rgb(213 80 154) 100%)",
				text: "#fff"
			},
			addTemplateButton: {
				background: "#7f305c",
				text: "#fff"
			},
			entrance: {
				background: "linear-gradient(45deg, #ffd4f2, #ffffff)",
				lid: "100px solid #962171",
				envelope_background: "#962171",
				envelope: `
					border-right: 130px solid #dc61a5;
		border-bottom: 100px solid #dc61a5;
		border-left: 150px solid #aa477e;`,
				view_invitation_btn: "#000"
			},
			footer: "#c44d8f"
		},
		[InvitationColorTheme.COLOR02]: {
			id: InvitationColorTheme.COLOR02,
			main: "#f08c8b",
			overlay: "linear-gradient(180deg, rgb(255 216 215) 0%, rgba(255, 255, 255, 1) 100%);",
			fader: "linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgb(255 217 216) 80%);",
			font: {
				primary: "#4b4b4b",
				secondary: "#000",
				tertiary: "#474747"
			},
			button: {
				background: "linear-gradient(180deg, rgb(253 132 129) 0%, rgb(174 90 88) 100%)",
				text: "#fff"
			},
			addTemplateButton: {
				background: "#d4433f",
				text: "#fff"
			},
			entrance: {
				background: "linear-gradient(45deg, #ffc7c6, #ffffff)",
				lid: "100px solid #fe8482",
				envelope_background: "#fe8482",
				envelope: `
				border-right: 130px solid #fa625e;
				border-bottom: 100px solid #fa625e;
				border-left: 150px solid #fba8a6;`,
				view_invitation_btn: "#000"
			},
			footer: "#f08c8b"
		},
		[InvitationColorTheme.COLOR03]: {
			id: InvitationColorTheme.COLOR03,
			main: "#d9d2e9",
			overlay: "linear-gradient(180deg, rgb(227 216 255) 0%, rgb(255 255 255) 100%);",
			fader: "linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgb(227 217 254) 80%);",
			font: {
				primary: "#4b4b4b",
				secondary: "#000",
				tertiary: "#474747"
			},
			button: {
				background: "linear-gradient(180deg, rgb(106 95 133) 0%, rgb(147 109 235) 100%)",
				text: "#fff"
			},
			addTemplateButton: {
				background: "#8170a6",
				text: "#fff"
			},
			entrance: {
				background: "linear-gradient(45deg, #d5c3fe, #ffffff)",
				lid: "100px solid #e1d4ff",
				envelope_background: "#e1d4ff",
				envelope: `
				border-right: 130px solid #d5c3fe;
				border-bottom: 100px solid #d5c3fe;
				border-left: 150px solid #eae1fe;`,
				view_invitation_btn: "#000"
			},
			footer: "#d9d2e9"
		},
		[InvitationColorTheme.COLOR04]: {
			id: InvitationColorTheme.COLOR04,
			main: "#709ba6",
			overlay: "linear-gradient(180deg, rgb(229 240 253) 0%, rgb(255 255 255) 100%);",
			fader: "linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgb(229 240 253) 80%);",
			font: {
				primary: "#4b4b4b",
				secondary: "#000",
				tertiary: "#fff"
			},
			button: {
				background: "linear-gradient(180deg, rgb(109 176 198) 0%, rgb(67 108 121) 100%);",
				text: "#fff"
			},
			addTemplateButton: {
				background: "#426c78",
				text: "#fff"
			},
			entrance: {
				background: "linear-gradient(45deg, #c0f0ff, #ffffff)",
				lid: "100px solid #95ccdd",
				envelope_background: "#95ccdd",
				envelope: `
				border-right: 130px solid #709ba7;
				border-bottom: 100px solid #709ba7;
				border-left: 150px solid #84b6c5;`,
				view_invitation_btn: "#000"
			},
			footer: "#709ba6"
		}
	},
	[TEMPLATES.TEMPLATES03]: {
		[InvitationColorTheme.COLOR01]: {
			id: InvitationColorTheme.COLOR01,
			main: "#5f2424",
			overlay: "linear-gradient(180deg, rgba(255, 245, 245, 1) 0%, rgba(255, 255, 255, 1) 100%)",
			font: {
				primary: "#4b4b4b",
				secondary: "#000",
				tertiary: "#fff"
			},
			button: {
				background: "linear-gradient(180deg, rgb(194 83 84) 0%, rgb(121, 5, 6, 1) 100%)",
				text: "#fff"
			},
			addTemplateButton: {
				background: "#560304",
				text: "#fff"
			},
			entrance: {
				background: "linear-gradient(45deg, #ffbdbd, #ffffff)",
				lid: "100px solid #a24646",
				envelope_background: "#a24646",
				envelope: `
				border-right: 130px solid #5f2424;
		border-bottom: 100px solid #5f2424;
		border-left: 150px solid #793838;`,
				view_invitation_btn: "#000"
			},
			footer: "#5f2424"
		},
		[InvitationColorTheme.COLOR02]: {
			id: InvitationColorTheme.COLOR02,
			main: "#bda788",
			overlay: "linear-gradient(180deg, rgb(255 228 203) 0%, rgba(255, 255, 255, 1) 100%);",
			font: {
				primary: "#4b4b4b",
				secondary: "#000",
				tertiary: "#fff"
			},
			button: {
				background: "linear-gradient(180deg, rgb(223 203 178) 0%, rgb(174 159 145) 100%);",
				text: "#fff"
			},
			addTemplateButton: {
				background: "#cdbdaf",
				text: "#fff"
			},
			entrance: {
				background: "linear-gradient(45deg, #ffe0be, #ffffff)",
				lid: "100px solid #e2d8ca",
				envelope_background: "#e2d8ca",
				envelope: `
				border-right: 130px solid #d4c7b7;
				border-bottom: 100px solid #d4c7b7;
				border-left: 150px solid #f0e4d2;`,
				view_invitation_btn: "#000"
			},
			footer: "#685a4a"
		},
		[InvitationColorTheme.COLOR03]: {
			id: InvitationColorTheme.COLOR03,
			main: "#bc5050",
			overlay: "linear-gradient(180deg, rgb(255 204 204) 0%, rgba(255, 255, 255, 1) 100%);",
			font: {
				primary: "#4b4b4b",
				secondary: "#000",
				tertiary: "#fff"
			},
			button: {
				background: "linear-gradient(180deg, rgb(188 81 81) 0%, rgb(255 110 110) 100%);",
				text: "#fff"
			},
			addTemplateButton: {
				background: "#a14444",
				text: "#fff"
			},
			entrance: {
				background: "linear-gradient(45deg, #ffbaba, #ffffff);",
				lid: "100px solid #d04b4b",
				envelope_background: "#d04b4b",
				envelope: `
				border-right: 130px solid #ac3d3d;
		border-bottom: 100px solid #ac3d3d;
		border-left: 150px solid #bc5454;`,
				view_invitation_btn: "#000"
			},
			footer: "#bc5050"
		},
		[InvitationColorTheme.COLOR04]: {
			id: InvitationColorTheme.COLOR04,
			main: "#c44d8f",
			overlay: "linear-gradient(180deg, rgba(243, 194, 215, 1) 0%, rgba(255, 255, 255, 1) 100%)",
			fader: "linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgb(244 196 216) 80%)",
			font: {
				primary: "#4b4b4b",
				secondary: "#000",
				tertiary: "#fff"
			},
			button: {
				background: "linear-gradient(180deg, rgb(127 48 93) 0%, rgb(213 80 154) 100%)",
				text: "#fff"
			},
			addTemplateButton: {
				background: "#7f305c",
				text: "#fff"
			},
			entrance: {
				background: "linear-gradient(45deg, #ffd4f2, #ffffff)",
				lid: "100px solid #962171",
				envelope_background: "#962171",
				envelope: `
					border-right: 130px solid #dc61a5;
		border-bottom: 100px solid #dc61a5;
		border-left: 150px solid #aa477e;`,
				view_invitation_btn: "#000"
			},
			footer: "#c44d8f"
		}
	},
	[TEMPLATES.TEMPLATES04]: {
		[InvitationColorTheme.COLOR01]: {
			id: InvitationColorTheme.COLOR01,
			main: "#c4e3b0",
			overlay: "linear-gradient(180deg, rgb(132 208 142) 0%, rgb(66, 106, 71, 1) 100%)",
			font: {
				primary: "#426a47",
				secondary: "#3f3f3f",
				tertiary: "#000"
			},
			button: {
				background: "linear-gradient(180deg, rgb(132 208 142) 0%, rgb(66, 106, 71, 1) 100%)",
				text: "#fff"
			},
			addTemplateButton: {
				background: "#314233",
				text: "#fff"
			},
			entrance: {
				background: "linear-gradient(45deg, #e6ffe8, #ffffff)",
				lid: "100px solid #abdaaf",
				envelope_background: "#abdaaf",
				envelope: `
		border-right: 130px solid #699d6e;
		border-bottom: 100px solid #699d6e;
		border-left: 150px solid #74ae7a;`,
				view_invitation_btn: "#000"
			},
			footer: "#c4e3b0"
		},
		[InvitationColorTheme.COLOR02]: {
			id: InvitationColorTheme.COLOR02,
			main: "#80b8c6",
			overlay: "linear-gradient(180deg, rgb(229 240 253) 0%, rgb(255 255 255) 100%);",
			fader: "linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgb(229 240 253) 80%);",
			font: {
				primary: "#2a7487",
				secondary: "#3f3f3f",
				tertiary: "#000"
			},
			button: {
				background: "linear-gradient(180deg, rgb(109 176 198) 0%, rgb(67 108 121) 100%);",
				text: "#fff"
			},
			addTemplateButton: {
				background: "#426c78",
				text: "#fff"
			},
			entrance: {
				background: "linear-gradient(45deg, #c0f0ff, #ffffff)",
				lid: "100px solid #95ccdd",
				envelope_background: "#95ccdd",
				envelope: `
				border-right: 130px solid #709ba7;
				border-bottom: 100px solid #709ba7;
				border-left: 150px solid #84b6c5;`,
				view_invitation_btn: "#000"
			},
			footer: "#80b8c6"
		},
		[InvitationColorTheme.COLOR03]: {
			id: InvitationColorTheme.COLOR03,
			main: "#a6aed1",
			overlay: "linear-gradient(180deg, rgb(183 216 255) 0%, rgb(255 255 255) 100%);",
			font: {
				primary: "#473b94",
				secondary: "#3f3f3f",
				tertiary: "#000"
			},
			button: {
				background: "linear-gradient(180deg, rgb(167 174 209) 0%, rgb(85 89 112) 100%);",
				text: "#fff"
			},
			addTemplateButton: {
				background: "#473b94",
				text: "#fff"
			},
			entrance: {
				background: "linear-gradient(45deg, #b7c4ff, #ffffff);",
				lid: "100px solid #8e9eef",
				envelope_background: "#8e9eef",
				envelope: `
				border-right: 130px solid #7c8acf;
		border-bottom: 100px solid #7c8acf;
		border-left: 150px solid #8190d5;`,
				view_invitation_btn: "#000"
			},
			footer: "#a6aed1"
		},
		[InvitationColorTheme.COLOR04]: {
			id: InvitationColorTheme.COLOR04,
			main: "#c97b7b",
			overlay: "linear-gradient(180deg, rgba(243, 194, 215, 1) 0%, rgba(255, 255, 255, 1) 100%)",
			fader: "linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgb(244 196 216) 80%)",
			font: {
				primary: "#5b2626",
				secondary: "#3f3f3f",
				tertiary: "#000"
			},
			button: {
				background: "linear-gradient(180deg, rgb(142 62 62) 0%, rgb(72 26 26) 100%)",
				text: "#fff"
			},
			addTemplateButton: {
				background: "#481f1f",
				text: "#fff"
			},
			entrance: {
				background: "linear-gradient(45deg, #ffdfdf, transparent);",
				lid: "100px solid #b46b6b",
				envelope_background: "#b46b6b",
				envelope: `
					border-right: 130px solid #a16262;
		border-bottom: 100px solid #a16262;
		border-left: 150px solid #834242;`,
				view_invitation_btn: "#000"
			},
			footer: "#c97b7b"
		}
	},
	[TEMPLATES.TEMPLATES05]: {
		[InvitationColorTheme.COLOR01]: {
			id: InvitationColorTheme.COLOR01,
			main: "#07080e",
			background: "linear-gradient(135deg, #4a5485, #131832)",
			secondaryBackground: "#fdf8f0",
			overlay: "linear-gradient(160deg, #404c87 0%, #3c4677 60%, #07080e 100%)",
			font: {
				primary: "#c9a84c",
				secondary: "#fff",
				tertiary: "#fff"
			},
			button: {
				background: "linear-gradient(135deg, #c9a84c, #a07830, #c9a84c)",
				text: "#fff"
			},
			addTemplateButton: {
				background: "#473b94",
				text: "#fff"
			},
			entrance: {
				background: "linear-gradient(45deg, #4a5485, #ffffff)",
				lid: "100px solid #8e9eef",
				envelope_background: "#8e9eef",
				envelope: `
				border-right: 130px solid #7c8acf;
		border-bottom: 100px solid #7c8acf;
		border-left: 150px solid #8190d5;`,
				view_invitation_btn: "#fff"
			},
			footer: "#07080e"
		},
		[InvitationColorTheme.COLOR02]: {
			id: InvitationColorTheme.COLOR02,
			main: "#4a1525",
			background: "linear-gradient(135deg, #4a1525, #6b2737)",
			secondaryBackground: "#fdf8f0",
			overlay: "linear-gradient(160deg, #4a1525 0%, #6b2737 60%, #8b3a4a 100%)",
			font: {
				primary: "#e8d5a3",
				secondary: "#fff",
				tertiary: "#fff"
			},
			button: {
				background: "linear-gradient(135deg, #c9a84c, #a07830, #c9a84c)",
				text: "#fff"
			},
			addTemplateButton: {
				background: "#4a1525",
				text: "#fff"
			},
			entrance: {
				background: "linear-gradient(45deg, #5b1c2a, #ffffff)",
				lid: "100px solid #4d0f1d",
				envelope_background: "#4d0f1d",
				envelope: `
    border-right: 130px solid #85243a;
    border-bottom: 100px solid #85243a;
    border-left: 150px solid #70182c;`,
				view_invitation_btn: "#fff"
			},
			footer: "#4a1525"
		},
		[InvitationColorTheme.COLOR03]: {
			id: InvitationColorTheme.COLOR03,
			main: "#00576d",
			background: "linear-gradient(135deg, #00576d, #182d33)",
			secondaryBackground: "#fdf8f0",
			overlay: "linear-gradient(160deg, #00576d 0%, #025165 60%, #09333e 100%)",
			fader: "linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgb(229 240 253) 80%);",
			font: {
				primary: "#c9a84c",
				secondary: "#fff",
				tertiary: "#fff"
			},
			button: {
				background: "linear-gradient(135deg, #c9a84c, #a07830, #c9a84c)",
				text: "#fff"
			},
			addTemplateButton: {
				background: "#426c78",
				text: "#fff"
			},
			entrance: {
				background: "linear-gradient(45deg, #1e3439, #ffffff)",
				lid: "100px solid #226072",
				envelope_background: "#226072",
				envelope: `
		    border-right: 130px solid #318297;
    	border-bottom: 100px solid #318297;
    	border-left: 150px solid #17434f;`,
				view_invitation_btn: "#fff"
			},
			footer: "#00576d"
		},
		[InvitationColorTheme.COLOR04]: {
			id: InvitationColorTheme.COLOR04,
			main: "#4d017a",
			background: "linear-gradient(135deg, #4d017a, #200430)",
			secondaryBackground: "#fdf8f0",
			overlay: "linear-gradient(160deg, #7933a2 0%, #3e0361 60%, #170224 100%)",
			fader: "linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgb(244 196 216) 80%)",
			font: {
				primary: "#c9a84c",
				secondary: "#fff",
				tertiary: "#fff"
			},
			button: {
				background: "linear-gradient(135deg, #c9a84c, #a07830, #c9a84c)",
				text: "#fff"
			},
			addTemplateButton: {
				background: "#4d017a",
				text: "#fff"
			},
			entrance: {
				background: "linear-gradient(45deg, #4d017a, #ffffff)",
				lid: "100px solid #672c8c",
				envelope_background: "#672c8c",
				envelope: `
			    border-right: 130px solid #4e186f;
    border-bottom: 100px solid #4e196f;
    border-left: 150px solid #2f0248;`,
				view_invitation_btn: "#fff"
			},
			footer: "#4d017a"
		}
	},
	[TEMPLATES.TEMPLATES06]: {
		[InvitationColorTheme.COLOR01]: {
			id: InvitationColorTheme.COLOR01,
			main: "#fce8d8",
			background: "linear-gradient(135deg, #8b3a47 0%, #6b2030 100%)",
			fader: "linear-gradient(180deg, rgb(255 255 255 / 0%) 20%, rgb(255 255 255) 60%);",
			secondaryBackground: "linear-gradient(135deg, #fde8e8 0%, #fce8d8 100%)",
			overlay: "linear-gradient(160deg, #404c87 0%, #3c4677 60%, #07080e 100%)",
			font: {
				primary: "#8b3a47",
				secondary: "#000",
				tertiary: "#000"
			},
			button: {
				background: "linear-gradient(135deg, #8a3946, #351435, #8a3946);",
				text: "#fff"
			},
			addTemplateButton: {
				background: "#8e3345",
				text: "#fff"
			},
			entrance: {
				background: "linear-gradient(45deg, #fce8d8, #ffffff)",
				lid: "100px solid #f9d1c6",
				envelope_background: "#f9d1c6",
				envelope: `
	    border-right: 130px solid #ffc7b7;
    border-bottom: 100px solid #ffc7b7;
    border-left: 150px solid #ffded4;`,
				view_invitation_btn: "#000"
			},
			footer: "#fce8d8"
		},
		[InvitationColorTheme.COLOR02]: {
			id: InvitationColorTheme.COLOR02,
			main: "#560e49",
			background: "linear-gradient(135deg, #831d84, #560e49)",
			fader: "linear-gradient(180deg, rgb(255 255 255 / 0%) 20%, rgb(255 255 255) 60%);",
			secondaryBackground: "linear-gradient(135deg, #fde8e8 0%, #fcd8f0 100%)",
			overlay: "linear-gradient(160deg, #4a1525 0%, #6b2737 60%, #8b3a4a 100%)",
			font: {
				primary: "#8b3a47",
				secondary: "#000",
				tertiary: "#fff"
			},
			button: {
				background: "linear-gradient(135deg, #811c81, #351435, #811c81)",
				text: "#fff"
			},
			addTemplateButton: {
				background: "#4d0f46",
				text: "#fff"
			},
			entrance: {
				background: "linear-gradient(45deg, #ffffff, #b776ab)",
				lid: "100px solid #92678a",
				envelope_background: "#92678a",
				envelope: `
    border-right: 130px solid #560e49;
    border-bottom: 100px solid #560e49;
    border-left: 150px solid #632358;`,
				view_invitation_btn: "#000"
			},
			footer: "#560e49"
		},
		[InvitationColorTheme.COLOR03]: {
			id: InvitationColorTheme.COLOR03,
			main: "#00576d",
			background: "linear-gradient(135deg, #00576d, #182d33)",
			fader: "linear-gradient(180deg, rgb(255 255 255 / 0%) 20%, rgb(255 255 255) 60%);",
			secondaryBackground: "linear-gradient(135deg, #e8f9fd 0%, #d8f1fc 100%)",
			overlay: "linear-gradient(160deg, #00576d 0%, #025165 60%, #09333e 100%)",
			font: {
				primary: "#2a7487",
				secondary: "#000",
				tertiary: "#fff"
			},
			button: {
				background: "linear-gradient(135deg, #016983, #293f45, #016983)",
				text: "#fff"
			},
			addTemplateButton: {
				background: "#426c78",
				text: "#fff"
			},
			entrance: {
				background: "linear-gradient(45deg, #2a484f, #61ddff)",
				lid: "100px solid #226072",
				envelope_background: "#226072",
				envelope: `
		     border-right: 130px solid #276c7e;
    border-bottom: 100px solid #276c7e;
    border-left: 150px solid #17434f;`,
				view_invitation_btn: "#000"
			},
			footer: "#00576d"
		},
		[InvitationColorTheme.COLOR04]: {
			id: InvitationColorTheme.COLOR04,
			main: "#4d017a",
			background: "linear-gradient(135deg, #4d017a, #200430)",
			fader: "linear-gradient(180deg, rgb(255 255 255 / 0%) 20%, rgb(255 255 255) 60%);",
			secondaryBackground: "linear-gradient(135deg, #f6e8fd 0%, #edd8fc 100%)",
			overlay: "linear-gradient(160deg, #7933a2 0%, #3e0361 60%, #170224 100%)",
			font: {
				primary: "#5b2626",
				secondary: "#000",
				tertiary: "#fff"
			},
			button: {
				background: "linear-gradient(135deg, #7400b8, #060407, #7400b8)",
				text: "#fff"
			},
			addTemplateButton: {
				background: "#4d017a",
				text: "#fff"
			},
			entrance: {
				background: "linear-gradient(45deg, #fdfaff, #8e52b0)",
				lid: "100px solid #672c8c",
				envelope_background: "#672c8c",
				envelope: `
			    border-right: 130px solid #4e186f;
    border-bottom: 100px solid #4e196f;
    border-left: 150px solid #2f0248;`,
				view_invitation_btn: "#000"
			},
			footer: "#4d017a"
		}
	},
	[TEMPLATES.TEMPLATES07]: {
		[InvitationColorTheme.COLOR01]: {
			id: InvitationColorTheme.COLOR01,
			main: "#2C1A0E",
			background: "#FAF6EF",
			secondaryBackground: "#F0E8D8",
			overlay: "rgba(44,26,14,0.55)",
			font: { primary: "#2C1A0E", secondary: "#7A5C3A", tertiary: "#B09070" },
			button: { background: "#2C1A0E", text: "#FAF6EF" },
			addTemplateButton: { background: "#7A5C3A", text: "#FAF6EF" },
			entrance: {
				background: "linear-gradient(45deg, #ffffff, #8b6248)",
				lid: "100px solid #5b473b",
				envelope_background: "#5b473b",
				envelope: `
border-right: 130px solid #2d1a0e;
    border-bottom: 100px solid #2d1a0e;
    border-left: 150px solid #432715;`,
				view_invitation_btn: "#fff"
			},
			footer: "#2C1A0E",
			fader: "rgba(250,246,239,0)"
		},
		[InvitationColorTheme.COLOR02]: {
			id: InvitationColorTheme.COLOR02,
			main: "#1A1A2E",
			background: "#F7F5F0",
			secondaryBackground: "#EAE4D8",
			overlay: "rgba(26,26,46,0.6)",
			font: { primary: "#1A1A2E", secondary: "#5C5470", tertiary: "#9A8FA8" },
			button: { background: "#1A1A2E", text: "#F7F5F0" },
			addTemplateButton: { background: "#5C5470", text: "#F7F5F0" },
			entrance: {
				background: "linear-gradient(45deg, #ffffff, #3d3d69)",
				lid: "100px solid #424277",
				envelope_background: "#424277",
				envelope: `
  border-right: 130px solid #1a1a2e;
    border-bottom: 100px solid #1a1a2e;
    border-left: 150px solid #313158;`,
				view_invitation_btn: "#fff"
			},
			footer: "#1A1A2E",
			fader: "rgba(247,245,240,0)"
		},
		[InvitationColorTheme.COLOR03]: {
			id: InvitationColorTheme.COLOR03,
			main: "#2E1A47",
			background: "#FBF8F4",
			secondaryBackground: "#EDE5F5",
			overlay: "rgba(46,26,71,0.58)",
			font: { primary: "#2E1A47", secondary: "#6B4F8A", tertiary: "#A890C0" },
			button: { background: "#2E1A47", text: "#FBF8F4" },
			addTemplateButton: { background: "#6B4F8A", text: "#FBF8F4" },
			entrance: {
				background: "linear-gradient(45deg, #ffffff, #584472)",
				lid: "100px solid #584472",
				envelope_background: "#92678a",
				envelope: `
    border-right: 130px solid #2e1a48;
    border-bottom: 100px solid #2e1a48;
    border-left: 150px solid #3c225e;`,
				view_invitation_btn: "#fff"
			},
			footer: "#2E1A47",
			fader: "rgba(251,248,244,0)"
		},
		[InvitationColorTheme.COLOR04]: {
			id: InvitationColorTheme.COLOR04,
			main: "#1C3228",
			background: "#F4F8F5",
			secondaryBackground: "#DDEEE5",
			overlay: "rgba(28,50,40,0.55)",
			font: { primary: "#1C3228", secondary: "#3D6B52", tertiary: "#7AA58E" },
			button: { background: "#1C3228", text: "#F4F8F5" },
			addTemplateButton: { background: "#3D6B52", text: "#F4F8F5" },
			entrance: {
				background: "linear-gradient(45deg, #ffffff, #1c3328)",
				lid: "100px solid #4d7965",
				envelope_background: "#4d7965",
				envelope: `
    border-right: 130px solid #1c3328;
    border-bottom: 100px solid #1c3328;
    border-left: 150px solid #2d493c;`,
				view_invitation_btn: "#fff"
			},
			footer: "#1C3228",
			fader: "rgba(244,248,245,0)"
		}
	},
	[TEMPLATES.TEMPLATES08]: {
		[InvitationColorTheme.COLOR01]: {
			id: InvitationColorTheme.COLOR01,
			main: "#8B1A2F",
			background: "#2A0A10",
			secondaryBackground: "#3D1020",
			overlay: "rgba(30, 5, 10, 0.72)",
			font: { primary: "#F5E6C8", secondary: "#D4AF37", tertiary: "#C9A96E" },
			button: { background: "#D4AF37", text: "#2A0A10" },
			addTemplateButton: { background: "#8B1A2F", text: "#F5E6C8" },
			footer: "#1A0508",
			fader: "#2A0A10",
			entrance: {
				background: "linear-gradient(45deg, #ffffff, #a91f39)",
				lid: "100px solid #801b2e",
				envelope_background: "#801b2e",
				envelope: `
    border-right: 130px solid #8c1a2f;
    border-bottom: 100px solid #8c1a2f;
    border-left: 150px solid #a91f39;
}`,
				view_invitation_btn: "#fff"
			}
		},
		[InvitationColorTheme.COLOR02]: {
			id: InvitationColorTheme.COLOR02,
			main: "#2C3E6B",
			background: "#0D1628",
			secondaryBackground: "#1A2540",
			overlay: "rgba(10, 15, 35, 0.75)",
			font: { primary: "#EDE8D8", secondary: "#C8A96A", tertiary: "#B89A5A" },
			button: { background: "#C8A96A", text: "#0D1628" },
			addTemplateButton: { background: "#2C3E6B", text: "#EDE8D8" },
			footer: "#080F1E",
			fader: "#0D1628",
			entrance: {
				background: "linear-gradient(45deg, #ffffff, #1e2f50)",
				lid: "100px solid #1f2f50",
				envelope_background: "#1f2f50",
				envelope: `
    border-right: 130px solid #2c3f6b;
    border-bottom: 100px solid #2c3f6b;
    border-left: 150px solid #3f4f76;`,
				view_invitation_btn: "#fff"
			}
		},
		[InvitationColorTheme.COLOR03]: {
			id: InvitationColorTheme.COLOR03,
			main: "#3B2314",
			background: "#1C0F08",
			secondaryBackground: "#2E1A0E",
			overlay: "rgba(20, 10, 5, 0.72)",
			font: { primary: "#F0E2C4", secondary: "#D4AF37", tertiary: "#C4A052" },
			button: { background: "#D4AF37", text: "#1C0F08" },
			addTemplateButton: { background: "#3B2314", text: "#F0E2C4" },
			footer: "#100804",
			fader: "#1C0F08",
			entrance: {
				background: "linear-gradient(45deg, #ffffff, #3c2313)",
				lid: "100px solid #64391f",
				envelope_background: "#64391f",
				envelope: `
  border-right: 130px solid #3c2313;
    border-bottom: 100px solid #3c2313;
    border-left: 150px solid #55311b;`,
				view_invitation_btn: "#fff"
			}
		},
		[InvitationColorTheme.COLOR04]: {
			id: InvitationColorTheme.COLOR04,
			main: "#1D3A28",
			background: "#0C1A12",
			secondaryBackground: "#162A1E",
			overlay: "rgba(8, 18, 12, 0.75)",
			font: { primary: "#EEE8D2", secondary: "#C9AA6D", tertiary: "#B89A5A" },
			button: { background: "#C9AA6D", text: "#0C1A12" },
			addTemplateButton: { background: "#1D3A28", text: "#EEE8D2" },
			footer: "#070E0A",
			fader: "#0C1A12",
			entrance: {
				background: "linear-gradient(45deg, #ffffff, #1d3a29)",
				lid: "100px solid #366b4c",
				envelope_background: "#366b4c",
				envelope: `
    border-right: 130px solid #1d3a29;
    border-bottom: 100px solid #1d3a29;
    border-left: 150px solid #29523a;`,
				view_invitation_btn: "#fff"
			}
		}
	}
};
